import { HOME_TYPE, HOTEL_TYPES } from "../../actions/types";

const initialState = {
  homes: [],
  home: null,
  errorMessage: "",
  add_hotel_tab: "details",
  edit_hotel_tab: "details",
  add_hotel: null,
  hotels: [],
  hotel: null,
};

const homeReducer = (state = initialState, action) => {
  switch (action.type) {
    case HOME_TYPE.SET_HOME:
      return {
        ...state,
        homes: [...action.homes],
      };
    case HOME_TYPE.ADD_HOME:
      return {
        ...state,
        status: action.payload.status,
        home: action.payload,
      };
    case HOME_TYPE.GET_HOME:
      return {
        ...state,
        home: action.payload,
      };
    case HOME_TYPE.EDIT_HOME:
      return {
        ...state,
        successMessage: action.payload.message,
      };
    case HOTEL_TYPES.ADD_HOTEL_SUCCESS:
      return {
        ...state,
        add_hotel: action.payload,
        add_hotel_tab: "rooms",
        hotel: null,
      };
    case HOTEL_TYPES.ADD_HOTEL_ROOM_SUCCESS:
      return {
        ...state,
        add_hotel: action.payload,
        add_hotel_tab: action.payload.tab || "images",
        hotel: null,
      };

    case HOTEL_TYPES.TOGGLE_ROOM_TAB:
      return {
        ...state,
        add_hotel_tab: action.payload,
        hotel: null,
      };
    case HOTEL_TYPES.PROPERTY_IMAGES_ADDED_SUCCESS:
      return {
        ...state,
        add_hotel: action.payload,
        add_hotel_tab: "details",
        hotel: null,
      };
    case HOTEL_TYPES.PROPERTIES_FETCH_SUCCESS:
      return {
        ...state,
        hotels: action.payload,
      };
    case HOTEL_TYPES.GET_HOTEL:
      return {
        ...state,
        hotel: action.payload,
        add_hotel: null,
        add_hotel_tab: "details",
      };
    case HOTEL_TYPES.TOGGLE_TAB:
      return {
        ...state,
        edit_hotel_tab: action.payload,
        add_hotel_tab: action.payload,
      };
    case HOTEL_TYPES.EDIT_HOTEL:
      return {
        ...state,
        hotel: action.payload,
        edit_hotel_tab: "rooms",
      };
    default:
      return state;
  }
};

export default homeReducer;
